import { createSlice } from "@reduxjs/toolkit";
import {
  FooterDataInitialStatus,
  GetFooterData,
} from "../../../../types/webCms/footer";
import { getAllFooterDataAsync, updateFooterDataAsync } from "./footerApi";

const initialState: FooterDataInitialStatus<GetFooterData> = {
  loading: false,
  manageLoading: false,
  footerDataList: [],
  countFooterData: 0,
};

const footerUpdateSlice = createSlice({
  name: "admin-discussion-Board",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // get all
    builder
      .addCase(getAllFooterDataAsync.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getAllFooterDataAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.footerDataList = action.payload.data;
        state.countFooterData = action.payload.length;
      })
      .addCase(getAllFooterDataAsync.rejected, (state) => {
        state.loading = false;
        state.footerDataList = [];
        state.countFooterData = 0;
      });

    // update
    builder
      .addCase(updateFooterDataAsync.pending, (state) => {
        state.manageLoading = true;
      })
      .addCase(updateFooterDataAsync.fulfilled, (state) => {
        state.manageLoading = false;
      })
      .addCase(updateFooterDataAsync.rejected, (state) => {
        state.manageLoading = false;
      });
  },
});

export default footerUpdateSlice;
